module.exports = __webpack_public_path__ + "static/media/soldoc_main_m.e2f7fe5.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/renew_mobile/soldoc_main_m.mp4
// module id = uPQW
// module chunks = 0